const css = `.feature-picker {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.feature-picker.disabled .p-checkbox {
  opacity: 0.6;
  pointer-events: none;
}
.feature-picker .feature-node {
  border: 1px solid var(--surface-border);
  background: var(--surface-card);
  margin-bottom: calc(var(--space-0-5) / -2);
}
.feature-picker .feature-node:first-child {
  border-top-left-radius: var(--border-radius);
  border-top-right-radius: var(--border-radius);
}
.feature-picker .feature-node:last-child {
  border-bottom-left-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
}
.feature-picker .feature-node .node-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: var(--surface-ground);
  border-bottom: 1px solid var(--surface-border);
}
.feature-picker .feature-node .node-header .node-title {
  display: flex;
  align-items: center;
  gap: 8px;
}
.feature-picker .feature-node .node-header .node-title i {
  color: var(--text);
  font-size: var(--font-size-lg);
}
.feature-picker .feature-node .node-header .node-title span {
  color: var(--text);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
}
.feature-picker .feature-node .node-header .node-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
}
.feature-picker .feature-node .node-header .node-toggle .toggle-label {
  font-size: var(--font-size-sm);
  color: var(--text-color-secondary);
}
.feature-picker .feature-node .node-header .node-toggle .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
  background: var(--text);
}
.feature-picker .feature-node .node-header .skeleton-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.feature-picker .feature-node .node-header .skeleton-title {
  border-radius: var(--border-radius);
}
.feature-picker .feature-node .node-header .skeleton-toggle {
  border-radius: var(--border-radius);
}
.feature-picker .feature-node .node-header .skeleton-switch {
  width: 36px;
  height: 20px;
  border-radius: 12px;
}
.feature-picker .feature-node .node-children {
  padding: 8px 24px;
}
.feature-picker .feature-node .node-children .feature-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid var(--surface-border);
}
.feature-picker .feature-node .node-children .feature-item:last-child {
  border-bottom: none;
}
.feature-picker .feature-node .node-children .feature-item .feature-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.feature-picker .feature-node .node-children .feature-item .feature-info .feature-label {
  font-size: var(--font-size-sm);
  color: var(--text-color);
}
.feature-picker .feature-node .node-children .feature-item .feature-status {
  font-size: var(--font-size-base);
}
.feature-picker .feature-node .node-children .feature-item .feature-status.pi-check {
  color: var(--success);
}
.feature-picker .feature-node .node-children .feature-item .feature-status.pi-times {
  color: var(--danger);
}
.feature-picker .feature-node .node-children .feature-item .p-checkbox {
  width: 18px;
  height: 18px;
}
.feature-picker .feature-node .node-children .feature-item .p-checkbox .p-checkbox-box {
  width: 18px;
  height: 18px;
  border-radius: 2px;
  transition: all 0.2s;
}
.feature-picker .feature-node .node-children .feature-item .p-checkbox .p-checkbox-box:not(.p-disabled):not(.p-highlight):hover {
  border-color: var(--text);
}
.feature-picker .feature-node .node-children .feature-item .p-checkbox .p-checkbox-box.p-highlight {
  border-color: var(--text);
  background: var(--text);
}
.feature-picker .feature-node .node-children .feature-item .p-checkbox .p-checkbox-box.p-highlight .p-checkbox-icon {
  color: var(--surface-raised);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
}
.feature-picker .feature-node .node-children .feature-item .p-checkbox .p-checkbox-box.p-focus {
  box-shadow: none;
  border-color: var(--text);
}
.feature-picker .feature-node .node-children .feature-item .skeleton-label {
  border-radius: var(--border-radius);
}
.feature-picker .feature-node .node-children .feature-item .skeleton-checkbox {
  width: 18px;
  height: 18px;
  border-radius: 2px;
}
@media screen and (max-width: 768px) {
  .feature-picker .feature-node .node-header,
  .feature-picker .feature-node .node-children {
    padding-left: 16px;
    padding-right: 16px;
  }
  .feature-picker .feature-node .node-header .node-toggle {
    gap: 8px;
  }
}
.feature-picker .p-skeleton {
  background-color: var(--surface-ground);
}
.feature-picker .p-skeleton::after {
  background: linear-gradient(90deg, transparent, var(--shimmer), transparent);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
